<template>
  <div>
    <div class="container" v-if="detailsData.goodsName">
      <!-- 分享
      <img
        src="https://img.esenyun.com/images/20200608/32b5d096fdc941838ef1f67c0b438fb5.png"
        class="share"
        @click="showShare = true"
      />
      <img
        src="https://img.esenyun.com/images/20200608/ba929e5a45cb45aaa353339ea658baa2.png"
        class="activity"
        v-if="showActivity"
        @click="backActivity"
      /> -->
      <div class="vcard-body" v-if="vcardData&&vcardData.avatar">
      <Vcard
        :posterData="vcardData"
        :posterImg="vcardUrl"
         @showMark="(e)=>callingcardShow=e"
      ></Vcard>
    </div>
      <div class="top" :style="{'margin-top': vcardData&&vcardData.avatar ? '64px' : 0}">
        <div class="logo">
          <img
            src="https://img.esenyun.com/images/20200523/7044e11bd11946b7a868a1fe6c6ef5c1.png"
            mode="widthFix"
            style="width:100px;"
          />
        </div>
        <div
          class="flex-center"
          style="justify-content: center; padding: 16px 0;"
        >
          <div class="flex-center countd">
            <div class="flex-center" v-if="timeType === 'end'">
              <div style="margin-right: 4px;">距离结束</div>
              <van-count-down :time="time">
                <template v-slot="timeData">
                  <div class="flex-center">
                    <span class="item flex-center">{{ timeData.hours }}</span>
                    <span class="tims">:</span>
                    <span class="item flex-center">{{ timeData.minutes }}</span>
                    <span class="tims">:</span>
                    <span class="item flex-center">{{ timeData.seconds }}</span>
                  </div>
                </template>
              </van-count-down>
            </div>
            <div v-else>
              {{ time }}
            </div>
          </div>
        </div>
      </div>
      <div class="shop">
        <div class="shop-msg flex-center">
          <div class="left">
            <img
              :src="
                detailsData.goodsType !== 'DISCOUNT'
                  ? 'https://img.esenyun.com/images/20200522/560e6b4bf0dd4092bf23f24c29aa1572.png'
                  : 'https://img.esenyun.com/images/20200603/58421dcf1a154a62a565a12b191701a3.png'
              "
              class="shop-type"
            />
            <img
              :src="
                detailsData.goodsType !== 'DISCOUNT'
                  ? detailsData.goodsImage
                  : 'https://img.esenyun.com/images/20200526/c100b48689ca42fea2f3a1e4cb22813d.png'
              "
              class="shop-img"
            />
            <div
              class="m-bg flex-center"
              v-if="detailsData.goodsType === 'DISCOUNT'"
            >
              <div class="discount flex-center">
                <div>{{ discount[0] }}</div>
                <div style="font-size: 30px; margin-bottom: 11px;">
                  .{{ discount[1] }}折
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="title van-multi-ellipsis--l2">
              {{ detailsData.goodsName }}
            </div>
            <div class="sub-title van-multi-ellipsis--l2">
              {{ detailsData.description }}
            </div>
            <van-tag type="success" color="#e02e2419" text-color="#E02E24"
              >剩余{{ detailsData.stockBalance }}件</van-tag
            >
            <div class="flex-center price">
              <div>秒杀价</div>
              <div
                class="flex-center"
                style="font-size: 20px;font-weight: bold;align-items: flex-end;"
              >
                <div style="font-size: 11px;">￥</div>
                <div style="height: 15px;">
                  {{ detailsData.seckillPrice }}
                </div>
              </div>
              <div class="old-price" v-if="detailsData.originalPrice">
                ￥{{ detailsData.originalPrice }}
              </div>
            </div>
          </div>
        </div>
        <div class="task" v-if="taskList.length">
          <div class="task-title">
            完成以下任意一个任务即可秒杀<img
              src="https://img.esenyun.com/images/20200523/50ac6eb264f34f32ad30dafcff1b407c.png"
            />
          </div>
        </div>
        <div class="task-container" v-if="taskList.length">
          <div
            class="flex-center task-box"
            style="justify-content: space-between;"
            v-for="(item, index) in taskList"
            :key="index"
          >
            <div>
              邀请{{
                item['conditionType'] == 'VISIT'
                  ? '访问'
                  : item['conditionType'] == 'ENTER'
                  ? '助力'
                  : item['conditionType'] == 'AMBASSADOR'
                  ? '转发'
                  : ''
              }}人数
            </div>
            <div class="flex-center">
              <progress value="0" max="100" />
              <div style="color: #89100d;margin-left: 8px;font-size: 14px;">
                <span style="color:#EA4638;">0</span>/{{ item.conditionNum }}
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="opt flex-center" style="justify-content: center;" @click="getWxcode">
              <button class="apply-btn"> 参加秒杀</button>
        </div> -->
        <div class="opt" @click="getWxcode">
          <van-button
            round
            style="color:#fff;font-weight: 600;font-size: 18px;border:none; width: 250px;background: linear-gradient(90.56deg, #FE7514 -3.31%, #EA4638 101.4%);box-shadow: 0px 8px 8px rgba(189, 185, 185, 0.5);"
            :disabled="
              loading ||
                detailsData.orderStatus === 'EXPIRED' ||
                detailsData.stockBalance === 0
            "
            v-if="
              taskSuc &&
                timeType === 'end' &&
                !seckillSuc &&
                detailsData.orderStatus !== 'SUCCESS'
            "
            >立即秒杀</van-button
          >
          <!-- <van-button
            round
            style="color:#EC4A36;font-weight: 600;font-size: 18px;border: 1px solid #EC4A36; background: #FFFFFF; width: 250px;box-shadow: 0px 8px 8px rgba(189, 185, 185, 0.2);"
            v-if="
              timeType === 'end' &&
                seckillSuc &&
                detailsData.orderStatus === 'WAIT_PAY'
            "
          >
            <div class="flex-center">
              继续支付<view class="pay-time"
                ><van-count-down :time="payTime" 
              /></view>
            </div>
          </van-button> -->
          <van-button
            round
            v-if="timeType === 'start'"
            style="color:#fff;font-weight: 600;font-size: 18px;border:none; width: 250px;background: linear-gradient(90.56deg, #FE7514 -3.31%, #FFBB00 101.4%);box-shadow: 0px 8px 8px rgba(189, 185, 185, 0.5);"
            :disabled="disableSeckill"
            >{{ disableSeckill ? '已预约' : '预约秒杀' }}</van-button
          >
          <!-- <van-button
            round
            style="margin-top: 16px;color:#fff;font-weight: 600;font-size: 18px;border:none; width: 250px;background: linear-gradient(90.56deg, #FE7514 -3.31%, #EA4638 101.4%);box-shadow: 0px 8px 8px rgba(189, 185, 185, 0.5);"
    
            :disabled="
              detailsData.orderStatus === 'EXPIRED' ||
                detailsData.stockBalance === 0
            "
            v-if="
              !taskSuc &&
                !seckillSuc &&
                (timeType === 'end' || timeType === 'start')
            "
            >去完成任务</van-button
          > -->
          <van-button
            round
            v-if="detailsData.orderStatus === 'SUCCESS'"
            disabled
            style="color:#fff;font-weight: 600;font-size: 18px;border:none; width: 250px;background: rgba(166, 166, 166, 0.98);box-shadow: 0px 8px 8px rgba(189, 185, 185, 0.5);"
            >秒杀成功</van-button
          >
        </div>
        <div class="avatar">
          <div class="end">
            {{ allShop }}人已抢
            <span style="margin: 0 5px; font-weight: 500;color: #ea4638;">{{
              allShop
            }}</span
            >件<span v-if="timeType === 'end'">，</span
            ><van-count-down
              :time="time"
              v-if="timeType === 'end'"
              @finish="finish"
            /><span v-if="timeType === 'end'">后结束</span>
          </div>
          <div
            class="img-box flex-center"
            v-if="userImgs.length"
            :style="{ height: userImgs.length > 8 ? '72px' : '36px' }"
          >
            <img :src="item" v-for="item in userImgs" :key="item" />
          </div>
        </div>
      </div>
      <!-- <div class="flex-center introduce">
        <img
          src="https://img.esenyun.com/images/20200608/195d879943584de1b2836663eca1ef3f.png"
          style="width:58px;height: 3px; margin-right: 8px;"
        />
        操作说明
        <img
          src="https://img.esenyun.com/images/20200608/4efad34dac0e4d1cb3925d8dfff855ce.png"
          style="width:58px;height: 3px;margin-left: 8px;"
        />
      </div> -->
      <!-- <div class="introduce-text">
        <text
          >返回活动，更多惊喜。点击活动页面下方“我要推广”分享活动，完成任务吧！</text
        >
      </div> -->
      <div class="flex-center introduce">
        <img
          src="https://img.esenyun.com/images/20200608/195d879943584de1b2836663eca1ef3f.png"
          style="width:58px;height: 3px; margin-right: 8px;"
        />
        规则说明
        <img
          src="https://img.esenyun.com/images/20200608/4efad34dac0e4d1cb3925d8dfff855ce.png"
          style="width:58px;height: 3px;margin-left: 8px;"
        />
      </div>
      <div class="introduce-text" v-html="transformText(detailsData.ruleDesc)"></div>
      <div
        class="flex-center introduce"
        v-if="
          detailsData.goodsType !== 'DISCOUNT' &&
            detailsData.goodsDetailImages &&
            detailsData.goodsDetailImages.length
        "
      >
        <img
          src="https://img.esenyun.com/images/20200608/195d879943584de1b2836663eca1ef3f.png"
          style="width:58px;height: 3px; margin-right: 8px;"
        />
        商品详情
        <img
          src="https://img.esenyun.com/images/20200608/4efad34dac0e4d1cb3925d8dfff855ce.png"
          style="width:58px;height: 3px;margin-left: 8px;"
        />
      </div>
      <div class="introduce-text"  v-if="detailsData.rightsRestrictDTOS&&detailsData.rightsRestrictDTOS.length>0">
          <div style="margin-bottom:12px;"> 1.秒杀成功后，如需退款，请拨打活动详情页上方联系电话处理</div>
          <div> 2.参与区域说明：仅支持在<span v-for="(item, index) in detailsData.rightsRestrictDTOS"
          :key="index">{{item.cityName}}<span v-if="index!=detailsData.rightsRestrictDTOS.length-1">、</span></span>的用户参与，感谢您的理解和支持。</div> 
      </div>
      <div class="goods-imgs">
        <van-image
          :src="item"
          lazy-load
          width="100%"
          fit="widthFix"
          v-for="(item, index) in detailsData.goodsDetailImages"
          :key="index"
        />
      </div>
    </div>
    <div class="flex-center empty" v-if="!detailsData.goodsName && error">
      <img
        src="https://img.esenyun.com/images/20200530/63d9945b5e184c7297536370071c693f.png"
      />
      <div class="text">很抱歉，该秒杀已经被删除</div>
    </div>
    <div class="footer flex-center" v-if="!callingcardShow">
      <div class="opt flex-center" style="justify-content: center;">
          <LinkWeappBtn
            :url="
              `fissionEquitys/seckilllDetail.html?seckillId=${seckillId}&shareId=${shareId}&shareType=${shareType}&seckillType=${detailsData.seckillType}`
            "
          >
            <script type="text/wxtag-template">
                <style>
                  .apply-btn {
                    width: 343px;
                    background: linear-gradient(90.12deg, #EA4638 2.31%, #DC2111 99.93%);
                    color: #fff;
                    font-size: 18px;
                    height: 44px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50px;
                    border: none;
                  }
                </style>
                <button class="apply-btn"> 去小程序参与
              </button>
            </script>
          </LinkWeappBtn>
        </div>
    </div>
    <van-popup v-model="qrModel" closeable :style="{ width: '100%' }">
      <div class="qr_code">
        <img :src="url" alt="" />
        <div>微信中长按识别小程序码</div>
        <div>参加秒杀</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import LinkWeappBtn from '../../components/LinkWeappBtn'
import Vcard from '../../components/Vcard'
export default {
  components: {
    LinkWeappBtn,
    Vcard
  },
  data() {
    return {
      qrModel: false,
      showActivity: false,
      error: false,
      time: 0,
      url: '',
      timeType: '',
      loading: false,
      timeData: {},
      couponId: '',
      seckillId: '',
      shareId: '',
      shareType:'',
      allShop: 0,
      reqTimes: 0,
      showShare: false,
      orderId: '',
      payTime: 0,
      taskSuc: false,
      detailsData: {
        seckillId: '',
        activityId: '',
        activityName: '',
        startDate: '',
        endDate: '',
        stockTotal: 0,
        stockBalance: 0,
        stockExpend: 0,
        stockIncome: 0,
        ruleDesc: '',
        conditionStatus: '',
        goodsType: '',
        goodsName: '',
        originalPrice: '',
        seckillPrice: '',
        goodsImage: '',
        goodsDetailImages: [],
        description: '',
        discount: 0,
        couponId: '',
        couponValue: '',
        duration: 0,
        conditionList: '',
        timeQuantum: '',
        couponExpiresTime: '',
        allowSalesParticipate: '',
        seckillStatus: '',
        subscribeRemind: '',
      },
      disableSeckill: false,
      seckillSuc: false,
      userImgs: [],
      taskList: [],
      vcardData:{},
      vcardUrl:'',
       callingcardShow:false
    }
  },
  computed: {
    discount: function() {
      if (this.detailsData.discount) {
        const discount = this.detailsData.discount + ''
        const discountArr = discount.split('.')
        if (discountArr.length < 2) {
          discountArr.push(0)
        }
        return discountArr
      } else {
        return [0, 0]
      }
    },
  },
  async mounted() {
    if (!this.$root.$data.store.state.isInitWx) {
      this.$root.$data.store.initwx(true, this.$route.query.code)
    }
    console.log(123, this.$route.meta)
    const opt = this.$route.query
    this.seckillId = opt.id||opt.seckillId
    this.shareId = opt.shareId
     this.shareType = opt.shareType||'invitation'
     if(this.$route.query.vcardData!='undefined'){
      this.vcardData = this.$route.query && this.$route.query.vcardData ? JSON.parse(this.$route.query.vcardData) : {}
     }
     this.vcardUrl = this.$route.query.vcardUrl
          ? this.$route.query.vcardUrl
          : ''
    this.getCardLDetails()
    this.getUserImg()
    this.getTask()
    this.readyShare()
  },
  methods: {
    transformText(text) {
      if(text) {
        text = text.replace(/\n/g, '<br />')
        return text
      }
    },
    readyShare() {
      if (this.$route.meta.from === '/') {
        window.wx.ready(async () => {
          this.setShare()
        })
      } else {
        this.setShare()
      }
    },
    setShare() {
      console.log(112)
      // alert('成功')
      // const shareUrl = encodeURIComponent(`https://dev-wxcp.nextxx.cn/campaign/#/?id=${this.id}`)
      const shareUrl = `${location.origin}${location.pathname}#/fissionEquitys/seckilllDetail?id=${this.seckillId}&shareId=${this.shareId}&shareType=${this.shareType}&vcardData=${encodeURIComponent(
          JSON.stringify(this.vcardData)
        )}&vcardUrl=${
              this.vcardUrl
            }`
      //需在用户可能点击分享按钮前就先调用
      window.wx.onMenuShareAppMessage({
        title: this.detailsData.goodsName, // 分享标题
        desc: this.detailsData.description, // 分享描述
        link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.detailsData.bannerUrl, // 分享图标
        success: () => {
          // 用户点击了分享后执行的回调函数
        },
      })
      window.wx.onMenuShareTimeline({
        title: this.detailsData.goodsName, // 分享标题
        link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.detailsData.bannerUrl, // 分享图标
        success: () => {
          // 用户点击了分享后执行的回调函数
        },
      })
    },
    async getWxcode() {
      this.url = await this.$share.getPosterNew(
        {
          seckillId: this.seckillId,
          shareId: this.shareId,
          shareType:this.shareType
        },
        'fissionEquitys/seckilllDetail'
      )
    },
    backActivity() {},
    goRule() {
      return (this.qrModel = true)
    },
    // md5解密活动id
    getMd5(code) {
      console
      return new Promise((s) => {
        this.$http
          .get('aocampaign/openapi/common/parms/restore?key=' + code)
          .then((res) => {
            console.log('%c 解密', 'color:orange', res.data)
            const ids = res.data.split('&')
            this.seckillId = ids[0]
            this.shareId = ids[1]
            this.shareType=ids[2]||'invitation'
            console.log(
              '%c ids',
              'color:orange',
              this.seckillId,
              this.shareId,
              this.shareType
            )
            s()
          })
      })
    },
    finish() {
      this.getCardLDetails()
    },
    // onChange({ detail }) {
    //   console.log(3123123123213213, detail)
    //   if (detail.hours < 10) {
    //     detail.hours = `0${detail.hours}`
    //   }
    //   if (detail.seconds < 10) {
    //     detail.seconds = `0${detail.seconds}`
    //   }
    //   if (detail.minutes < 10) {
    //     detail.minutes = `0${detail.minutes}`
    //   }
    //   if (detail.days) {
    //     detail.hours = +detail.hours + detail.days * 24
    //   }
    //   this.timeData = detail
    // },
    // 预约秒杀
    subscribeSeckill() {
      return (this.qrModel = true)
    },
    // 秒杀状态
    // EXPIRED("已失效"),
    // WAIT_PAY("待支付"),
    // SUCCESS("已完成"),
    // WAIT_SHIP("待发货"),
    // ALREADY_BOOKED("已预约"),
    // WITHOUT_RESERVATIONS("未预约")
    // 获取详情
    getCardLDetails() {
      this.$http
        .get(`aoseckill/openapi/user/seckillRightsInterestResource/detail/${this.seckillId}?shareId=${this.shareId}`)
        .then(async (res) => {
          if (!res.data) {
            return false
          }
          res.data.goodsDetailImages =
            res.data.goodsDetailImages != '' &&
            res.data.goodsDetailImages != null
              ? res.data.goodsDetailImages.split(',')
              : []
          console.log(res.data.goodsDetailImages)
          this.detailsData = res.data
          this.time = this.getStatus()
          // this.isSubscribe()
          if (this.detailsData.orderStatus === 'WITHOUT_RESERVATIONS') {
            this.disableSeckill = false
          }
          if (this.detailsData.orderStatus === 'EXPIRED') {
            this.$Dialog
              .alert({
                title: '秒杀失去资格',
                message:
                  '因您超时未支付，失去该秒杀资格，请您下次及时支付完成秒杀。',
              })
              .then(() => {
                // on close
              })
          }
          if (this.detailsData.orderStatus === 'ALREADY_BOOKED') {
            this.disableSeckill = true
          }
          if (
            this.detailsData.orderStatus === 'WAIT_PAY' &&
            this.timeType === 'end'
          ) {
            this.$Dialog
              .alert({
                title: '秒杀待支付',
                message:
                  '您已成功锁定秒杀资格，需要支付后生效，超时不支付将失去该秒杀资格。',
              })
              .then(() => {
                // on close
              })
            this.seckillSuc = true
            this.orderId = this.detailsData.orderId
            this.payTime = this.moment(this.detailsData.expiresTime).diff(
              this.moment(),
              'ms'
            )
            console.log('payTime', this.payTime)
          }
        })
        .catch(() => {
          this.error = true
        })
    },
    payOver() {
      this.detailsData.orderStatus = 'WAIT_PAY'
      this.$Dialog
        .alert({
          title: '秒杀失去资格',
          message: '因您超时未支付，失去该秒杀资格，请您下次及时支付完成秒杀。',
        })
        .then(() => {
          // on close
        })
    },
    getStatus() {
      const data = this.detailsData
      if (!data.startDate) return
      const startDate = this.moment(data.startDate).minute(0)
      const endDate = this.moment(data.startDate)
        .minute(0)
        .add('m', +data.duration)
      if (data.startDate) {
        // 结束时间小于当前时间
        if (endDate < this.moment()) {
          this.timeType = 'over'
          return '秒杀已结束'
        } else {
          // 开始时间大于当前时间（未开始）
          if (startDate > this.moment()) {
            // 判断 开始时间是否大于本日
            if (
              startDate >=
              this.moment()
                .startOf('day')
                .add('d', 1)
            ) {
              this.timeType = 'start'
              return '开始时间 ' + startDate.format('MM-DD HH:mm')
            } else {
              this.timeType = 'start'
              return '等待开始 ' + startDate.format('HH:mm')
            }
          } else {
            this.timeType = 'end'
            return endDate.diff(this.moment(), 'ms')
          }
        }
      }
    },
    // 获取用户头像
    getUserImg() {
      this.$http
        .get(`aoseckill/openapi/user/seckill/userAvatar/${this.seckillId}`)
        .then((res) => {
          if (!res.data) {
            return false
          }
          if (res.data.avatars && res.data.avatars.length) {
            res.data.avatars = res.data.avatars.slice(0, 16)
          }
          this.userImgs = res.data.avatars
          this.allShop = res.data.stockExpend
        })
    },
    // 获取任务
    getTask() {
      // this.$http
      //   .get(
      //     `aoseckill/openapi/user/seckill/killConditions/${this.seckillId}`
      //   )
      //   .then((res) => {
      //     if (!res.data) {
      //       this.taskSuc = true
      //       return false
      //     }
      //     this.taskList = res.data
      //     this.taskSuc = false
      //     this.taskList.forEach((item) => {
      //       if (item.conditionNum <= item.satisfyNum) {
      //         item.satisfyNum = item.conditionNum
      //         this.taskSuc = true
      //       }
      //     })
      //   })
    },
    // 秒杀操作
    seckillBtn() {
      return (this.qrModel = true)
      // if (this.loading) return
      // this.loading = true
      // this.$http
      // .post(
      //   `aoseckill/openapi/user/seckill/submit/${this.seckillId}?activityId=${this.activityId}`
      // )
      // .then(() => {
      //   this.reqTimes = 0
      //   this.getSearchRes()
      // })
      // .catch(() => {
      //   this.loading = false
      // })
    },
    // 查询结果
    getSearchRes() {
      return this.$http
        .get(
          `aoseckill/openapi/user/seckillRightsInterestResource/pay-result/${this.orderId}`
        )
        .then(async (res) => {
          this.reqTimes++
          if (this.reqTimes === 20) {
            this.loading = false
            this.getCardLDetails()
            return this.$Toast('查询超时')
          }
          if (res.data.status === 'SECKILL_WAIT_RESULT') {
            setTimeout(() => {
              this.getSearchRes()
            }, 1000)
          }
          if (res.data.status === 'SECKILL_SUCCESS') {
            this.seckillSuc = true
            this.orderId = res.data.orderId
            await this.getCardLDetails()
            this.PaySeckill()
          }
        })
    },
    // 付款
    PaySeckill() {},
    // 查询支付结果
    getPayRes() {},
    // 获取订阅消息
    getMessage() {},
  },
}
</script>

<style lang="less" scoped>
.footer {
  padding: 12px 0 20px 0;
  justify-content: center;
  .btn {
    padding: 0 6px;
  }
  .active {
    justify-content: center;
  }
}
 .apply-btn {
   width: 343px;
   background: linear-gradient(270deg, #EA4638 0%, #DC2111 100%);
    color: #fff;
    font-size: 16px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 40px;
    border: none;
}
.van-count-down {
  color: #000;
}
.qr_code {
  width: 100%;
  background: #fff;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  color: #323233;
  padding: 10px;
  img {
    width: 80%;
    margin: 18px auto;
  }
}
progress {
  -webkit-appearance: none;
  width: 100px;
  height: 8px;
  border-radius: 8px;
  background: #eed8d8;
}
img {
  display: inline-block;
}
.empty {
  height: 100vh;
  justify-content: center;
  flex-direction: column;
  img {
    width: 160px;
    height: 180px;
  }
  .text {
    font-size: 14px;
    line-height: 22px;
    color: #7d7e80;
    text-align: center;
    margin-top: 24px;
  }
}
/deep/.van-tag {
  --tag-border-radius: 3px;
}
/deep/.van-image {
  display: block;
}
.pay-time {
  margin-left: 5px;
  --count-down-text-color: #ec4a36;
}
.container {
  min-height: 100vh;
  background: linear-gradient(
    168.07deg,
    #e42a28 0%,
    rgba(245, 112, 70, 0.88) 50.66%,
    #e6332d 77.11%
  );
  padding-bottom: 120px;
  .share {
    width: 72px;
    height: 32px;
    position: fixed;
    right: 0;
    bottom: 32px;
    z-index: 10;
  }
  .activity {
    .share;
    bottom: 76px;
  }
  .top {
    height: 118px;
    background: url('https://img.esenyun.com/images/20200523/0aff7a45ffb44ce285cfdcfde3dda3d1.png')
      no-repeat;
    background-size: 100%;
    .logo {
      padding-top: 26px;
      text-align: center;
    }
  }
  .countd {
    height: 32px;
    border-radius: 3px;
    justify-content: center;
    padding: 0 24px;
    color: #fff;
    background: #dc3f31;
  }
  .tims {
    font-size: 14px;
    color: #fff;
    line-height: 24px;
    font-weight: bold;
    margin: 0 2px;
  }
  .item {
    min-width: 10px;
    height: 20px;
    padding: 0 3px;
    font-size: 14px;
    color: #dc3f31;
    background: #fff;
    justify-content: center;
  }
}
.shop {
  margin: 0 12px;
  padding: 12px;
  background: #fff;
  border-radius: 3px;
  align-items: flex-start;
  .shop-msg {
    justify-content: space-between;
  }
  .left {
    width: 127px;
    height: 127px;
    position: relative;
    border-radius: 3px;
    overflow: hidden;
    .m-bg {
      width: 127px;
      height: 127px;
      justify-content: center;
      font-weight: bold;
      font-size: 60px;
      color: #fd533e;
      position: absolute;
      top: 0;
      .discount {
        align-items: flex-end;
      }
    }
    .shop-img {
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
    .shop-type {
      width: 46px;
      height: 20px;
      position: absolute;
      left: -1px;
      top: 0;
      z-index: 1;
    }
  }
  .right {
    height: 127px;
    // max-width: 368rpx;
    flex: 1;
    margin-left: 16px;
    position: relative;
    .title {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    }
    .sub-title {
      margin-top: 2px;
      font-size: 11px;
      line-height: 12px;
      margin-bottom: 8px;
      color: #4a4a4a;
    }
    .tag {
      font-size: 11px;
      line-height: 15px;
      color: #e02e24;
      background: rgba(224, 46, 36, 0.1);
      border-radius: 3px;
    }
    .price {
      font-size: 11px;
      line-height: 12px;
      color: #f5222d;
      position: absolute;
      bottom: 0;
      .old-price {
        line-height: 16px;
        color: #7d7e80;
        text-decoration-line: line-through;
      }
    }
  }
}
.task {
  margin-top: 17px;
  height: 28px;
  background: #ea4638;
  border-radius: 3px 3px 0px 0px;
  overflow: hidden;
  .task-title {
    font-size: 14px;
    line-height: 22px;
    color: #fff;
    padding: 0 12px;
    background: #a71713;
    display: inline-block;
    position: relative;
    img {
      width: 17px;
      height: 24px;
      position: absolute;
      top: 0;
      right: -13px;
    }
  }
}
.task-container {
  // height: 100px;
  padding: 12px;
  background: #fff5f5;
  border-radius: 3px;
  margin-top: -6px;
}
.opt {
  padding-top: 12px;
  padding-bottom: 24px;
  text-align: center;
}
.avatar {
  padding: 12px 22px;
  background: #fff5f5;
  border-radius: 3px;
  .end {
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    --count-down-text-color: #ea4638;
    /deep/.van-count-down {
      font-weight: 500;
      display: inline-block;
      margin-right: 5px;
    }
  }
  .img-box {
    margin-top: 8px;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
    height: 72px;
  }
  img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-bottom: 4px;
    margin-right: 4px;
  }
}
.introduce {
  justify-content: center;
  margin-top: 20px;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #fff3ce;
}
.introduce-text {
  margin: 8px 12px 0 12px;
  background: #fff;
  border-radius: 3px;
  padding: 12px;
  font-size: 14px;
  line-height: 22px;
  color: #4a4a4a;
}
.goods-imgs {
  padding: 8px 12px;
}
.task-box {
  margin-top: 8px;
}
.task-box:first-child {
  margin-top: 0;
}
.vcard-body {
    width: 100%;
    position: fixed;
    z-index: 99;
    top: 0;
    background: #fff;
    height: 64px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    padding: 0 16px;
  }
</style>
